import { DataConverter, ConfigHelper } from 'services/charting';

export default class DetailsChartController {
    /** @ngInject */
    constructor() {
        this.chartData = [];
        this.chartType = null;
        this.chartConfig = {};
    }

    prepareTemperatureConfig() {
        const data = DataConverter.temperature(this.chartData);
        this.chartConfig = ConfigHelper.temperaturePreview(data);
    }

    prepareTouchConfig() {
        const data = DataConverter.touch(this.chartData);
        this.chartConfig = ConfigHelper.touchPreview(data);
    }

    prepareProximityConfig() {
        const data = DataConverter.proximity(this.chartData);
        this.chartConfig = ConfigHelper.proximityPreview(data);
    }

    prepareChartConfig() {
        if (this.chartType === 'temperature') {
            this.prepareTemperatureConfig();
        } else if (this.chartType === 'touch') {
            this.prepareTouchConfig();
        } else {
            this.prepareProximityConfig();
        }
    }

    $onChanges(changes) {
        if (changes.chartData && changes.chartData.currentValue) {
            this.chartData = changes.chartData.currentValue.values || [];
        }

        if (changes.chartType) {
            this.chartType = changes.chartType.currentValue;
        }

        if (changes.chartData || changes.chartType) {
            this.prepareChartConfig();
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/details-chart/details-chart.controller.js